//renders a color based on the Role
export const ROLECOLOR = {
    "Artisan": "rgba(52, 152, 219, 0.4)",
    "Work Lead": "rgba(231, 76, 60, 0.4)",
    "Shop Supervisor": "rgba(241, 196, 15, 0.4)",
    "Engineer": "rgba(46, 204, 113, 0.4)",
    "E&E": "rgba(155, 89, 182, 0.4)",
    "QA": "rgba(26, 188, 156, 0.4)",
    "Dev": "rgba(52, 73, 94, 0.4)"
}

export const ROLETEXTCOLOR = {
    "Artisan": "white",
    "Work Lead": "white",
    "Shop Supervisor": "white",
    "Engineer": "white",
    "E&E": "white",
    "QA": "white",
    "Dev": "white"
}

//renders a color based on device status
export const STATUS = {
    "Online": "#00ac00",
    "Offline": "gainsboro"
}
//color preset imported and used in ColorPicker component.
                //red, orange, yellow, blue, green, voilet, indigo, black, brown, white
                // maroon, light orange, light yellow, lime green, violet, purple, blue
export const presetColorSwatches = ['#F9F9F9', '#C8C8C8', '#6D6D6D', '#0E0D0D', '#BA3333', '#3FAF58', '#3369BA', '#A56D2D']

//used in WI Author/Previewer. Specifically when dealing with attachments.
export const imageExtensions = ["png", "PNG", "tiff", "TIFF", "jpg", "JPG", "jpeg", "JPEG"]
export const videoExtensions = ["mov", "MOV", "mp4", "MP4"]
export const audioExtensions = ["mp3", "MP3"]
export const documentExtensions = ["pdf", "PDF"]
//"fbx", "FBX", "dwg", "DWG",, "glb", "GLB", "3DXML", "3dxml", "jt","JT", "stl", "STL","usdz", "USDZ", "STP", "stp", "step", "STEP" 

export const modelExtensions = [ "obj","OBJ","fbx","FBX","stl","STL","ply","PLY","gltf","GLTF","glb","GLB"]

export const sampleGridColumns = [
    { key: "nomenclature", name: 'Nomenclature' },
    { key: "designation_partNumber", name: 'Designation/Part Number' },
    { key: "cage", name: 'Cage' },
];

export const sampleGridRows = [
    {
        id: 0,
        nomenclature: 'Adapter Assembly Holdback Fixture',
        designation_partNumber: '74D130505-1001',
        cage: 76301,
    },
    {
        id: 1,
        nomenclature: 'E/F Adaptor'
    },
    {
        id: 2,
        nomenclature: 'Etching Tool, Vibrating'
    },
    {
        id: 3,
        nomenclature: 'Test Fixture',
        designation_partNumber: 'A51S64140-1',
        cage: '26512'
    }
]

export const validTableChars = () => {
    const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    const alphabet = alpha.map((x) => String.fromCharCode(x));
    let valid = {}
    alphabet.forEach(char => {
        valid[char] = true
        valid[char.toLowerCase()] = true
    })
    nums.forEach(num => {
        valid[num.toString()] = true
    })
    return valid
}